import { Box, ButtonBase } from '@mui/material';

function TouchableImage({ image_path, image_alt, onClick }) {
  return (
    <ButtonBase onClick={onClick}>
      <Box
        component="img"
        src={image_path}
        alt={image_alt}
        sx={{
          width: 200, // Adjust the width as needed
          height: 'auto', // Maintain aspect ratio
        }}
      />
    </ButtonBase>
  );
}

export default TouchableImage;